import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import supabase from '../../supabaseClient'
import Loader from '../Loader'
import SignupLayout from './SignupLayout'
import {
  fetchExistingVenueMembership,
  venueOwnerLoginRedirectState,
} from '../../utils/existingVenueCheck'

/**
 * Blocks venue owner signup when the signed-in user is already linked
 * to a venue. Redirects to /venue-owner/login with alreadyInVenue state.
 */
export default function VenueSignupGuard({ children }) {
  const navigate = useNavigate()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let cancelled = false

    async function run() {
      const {
        data: { session },
      } = await supabase.auth.getSession()

      if (!session?.user) {
        if (!cancelled) setReady(true)
        return
      }

      const membership = await fetchExistingVenueMembership(session.user.id)
      if (!membership) {
        if (!cancelled) setReady(true)
        return
      }

      if (!cancelled) {
        navigate('/venue-owner/login', {
          replace: true,
          state: venueOwnerLoginRedirectState(membership.venueName),
        })
      }
    }

    run()
    return () => {
      cancelled = true
    }
  }, [navigate])

  if (!ready) {
    return (
      <SignupLayout showLogin={false}>
        <div className="flex flex-col items-center justify-center pt-12">
          <Loader size={28} className="text-[var(--signup-bg-base)]" />
        </div>
      </SignupLayout>
    )
  }

  return children
}
